"use client";

import Form, { StringInput, EmailInput, DropdownInput, TextareaInput } from "@/components/forms";
import { SupportForm as schema } from "@/types";

type Props = {}

export const SupportForm: React.FC<Props> = ({ }) => {
    return (
        <Form code="support" schema={schema} title="Get Help & Support" description="Please fill out the form below to receive help & support from our support team." buttonName="Get Help" initialValues={{ category: "", organizationId: "", message: "" }}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <StringInput name="firstName" label="What is your first name?" description="required" placeholder="e.g. John" />
                <StringInput name="lastName" label="What is your last name?" description="required" placeholder="e.g. Doe" />
                <EmailInput name="email" label="What is your email address?" description="required" placeholder="e.g. john.doe@example.com" />
                <StringInput name="company" label="What is your company's name?" description="optional" placeholder="e.g. Acme Inc." />
            </div>
            <p className="text-md font-semibold">Issue</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <DropdownInput name="category" label="What type of support do you need?" description="required" options={{
                    "General Inquiry": "General Inquiry",
                    "Feature Request": "Feature Request",
                    "Billing & Payments": "Billing & Payments",
                    "Partnerships & Collaborations": "Partnerships & Collaborations",
                    "Privacy & Security": "Privacy & Security",
                    "Technical Issue": "Technical Issue",
                }} />
                <StringInput name="organizationId" label="What is your organization ID?" description="optional" placeholder="e.g. 9bddf5bd-5287-42dc-bab3-e61b327b04d9" />
            </div>
            <TextareaInput name="message" label="Please describe your issue or question in detail:" description="required" placeholder="Provide as much detail as possible to help us assist you effectively..." />
        </Form>
    );
}